import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const StarEmptyIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M32 1.42553c1.1073 0 2.1185.62857 2.6086 1.62145l8.3129 16.84097 18.5901 2.7172c1.0954.1601 2.005.9281 2.3465 1.9812.3414 1.0532.0556 2.2088-.7375 2.9812l-13.4493 13.0997 3.1741 18.5064c.1871 1.0914-.2616 2.1945-1.1575 2.8453-.8959.6509-2.0837.7366-3.0638.2212L32 53.49765l-16.6241 8.7425c-.9801.5154-2.1679.4297-3.0638-.2212-.8959-.6508-1.3446-1.7539-1.1575-2.8453l3.1741-18.5064L.87941 27.56755c-.79307-.7724-1.07895-1.928-.7375-2.9812.34147-1.0531 1.25108-1.8211 2.34652-1.9812l18.59007-2.7172 8.3129-16.84097C29.8815 2.0541 30.8927 1.42553 32 1.42553zm0 9.48142l-6.3805 12.9262c-.4234.8577-1.2413 1.4525-2.1878 1.5908l-14.27262 2.0862 10.32522 10.0568c.6862.6683.9994 1.6316.8375 2.5757l-2.4361 14.204 12.7603-6.7105c.8476-.4458 1.8604-.4458 2.708 0l12.7603 6.7105-2.4361-14.204c-.1619-.9441.1513-1.9074.8375-2.5757l10.3252-10.0568-14.2726-2.0862c-.9465-.1383-1.7644-.7331-2.1878-1.5908z"
    />
  </IconBox>
);

export default StarEmptyIcon;
